import { render, staticRenderFns } from "./generate_permalink.vue?vue&type=template&id=48ccf630&"
import script from "./generate_permalink.vue?vue&type=script&lang=js&"
export * from "./generate_permalink.vue?vue&type=script&lang=js&"
import style0 from "./generate_permalink.vue?vue&type=style&index=0&id=48ccf630&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports